import React, { memo } from 'react';
import { Check, X } from 'lucide-react';
import { AudioPlayer } from './AudioPlayer';
export function DetailsSection() {
  return <section className="py-20 bg-transparent px-4" data-id="element-97">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-98">
        {/* Left Column: What's Included */}
        <div data-id="element-99">
          <h2 className="text-3xl font-semibold text-[#3A3A3A] mb-8" data-id="element-100">
            Qué incluye el sistema
          </h2>
          <div className="space-y-4" data-id="element-101">
            {['El Protocolo 5-Min (paso a paso detallado)', 'Versiones rápidas para oficina, tráfico y metro', 'Checklists visuales (para no depender de tu memoria)', 'Guía de señales de alarma y seguridad', 'BONUS: Audios guiados para practicar'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-102">
                <div className="mt-1 w-5 h-5 rounded-full bg-[#5BBFB5]/10 flex items-center justify-center shrink-0" data-id="element-103">
                  <Check className="w-3 h-3 text-[#5BBFB5]" data-id="element-104" />
                </div>
                <p className="text-[#3A3A3A] font-light" data-id="element-105">{item}</p>
              </div>)}
          </div>

          {/* Audio Preview */}
          <div className="mt-8" data-id="element-106">
            <AudioPlayer src="https://drive.google.com/uc?export=download&id=1I7hTD0qeLSXqeV5qKBZXhTV43Xg3jB11" title="Audio Guiado Protocolo 5-Min" subtitle="Escucha una muestra del producto" data-id="element-107" />
          </div>
        </div>

        {/* Right Column: Who is this for */}
        <div className="space-y-6" data-id="element-108">
          <div className="bg-white border border-[#E8E8E6] rounded-2xl p-6 md:p-8 shadow-sm" data-id="element-109">
            <h3 className="font-semibold text-[#3A3A3A] mb-4 flex items-center gap-2" data-id="element-110">
              <span className="text-[#5BBFB5]" data-id="element-111">●</span> Es para ti si:
            </h3>
            <ul className="space-y-3 text-sm text-[#7A7A7A]" data-id="element-112">
              {['Te agarra ansiedad repentina y necesitas bajar intensidad rápido.', 'Odias los métodos largos y teóricos.', 'Buscas algo discreto que no llame la atención en público.'].map((text, i) => <li key={i} className="flex gap-2 font-light" data-id="element-113">
                  <Check className="w-4 h-4 text-[#5BBFB5] shrink-0 mt-0.5" data-id="element-114" />
                  <span data-id="element-115">{text}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-[#F7F7F5] border border-[#E8E8E6] rounded-2xl p-6 md:p-8" data-id="element-116">
            <h3 className="font-semibold text-[#7A7A7A] mb-4 flex items-center gap-2" data-id="element-117">
              <span className="text-red-400" data-id="element-118">●</span> No es para ti si:
            </h3>
            <ul className="space-y-3 text-sm text-[#7A7A7A]" data-id="element-119">
              {['Buscas diagnóstico clínico o tratamiento médico psiquiátrico.', 'Quieres una solución mágica sin practicar al menos 2 minutos.'].map((text, i) => <li key={i} className="flex gap-2 font-light" data-id="element-120">
                  <X className="w-4 h-4 text-red-400 shrink-0 mt-0.5" data-id="element-121" />
                  <span data-id="element-122">{text}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}